<template>
  <div class="card">
    <div class="row clearfix">
      <!-- Spinners -->
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <!-- <div class="header">
                        <h2><strong>Form Editor</strong></h2>
                    </div> -->
          <div class="body" v-if="fieldForm">
            <div class="col-lg-12 col-md-12 col-sm-12" style="padding-right: 0">
              <p>
                유저가 전달이 필요한 문구를 쓸 수 있는 필드를 생성합니다. 해당
                트리거에 필요한 필드들을 추가하세요.
              </p>
              <button class="btn btn-default" @click="viewInputFieldArea(10)">
                추가
              </button>
            </div>
          </div>
          <div class="body" v-if="containing">
            <div
              class="col-lg-12 col-md-12 col-sm-12"
              style="text-align: right"
            >
              <button
                class="btn btn-default"
                style="text-align: center;"
                @click="viewInputFieldArea(10)"
              >
                추가
              </button>
            </div>
            <div class="body planned_task" v-if="!fieldForm">
              <div class="table-responsive">
                <table class="table table-hover" style="text-align: center">
                  <thead>
                    <th >#</th>
                    <th >키</th>
                    <th >라벨</th>
                    <!-- <th>타입</th> -->
                    <!-- <th>중요</th> -->
                    <!-- <th>보임</th> -->

                    <th >&nbsp;</th>
                  </thead>
                  <tbody>
                    <tr v-for="(trig, index) in trigList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td @click="toEditPage(index)">
                        {{ trig.keys.replace(/"/gi, "") }}
                      </td>
                      <td @click="toEditPage(index)">
                        {{ trig.label.replace(/"/gi, "") }}
                      </td>
                      <!-- <td>{{trig.type.replace(/"/gi, "") }}</td> -->

                      <!-- <td>{{ getVisible(trig.require) }}</td> -->
                      <!-- <td>-</td> -->
                      <td>
                        <a href="javascript:void(0);" @click="toEditPage(index)"
                          >수정</a
                        >
                        &nbsp;&nbsp;&nbsp;
                        <a
                          href="javascript:void(0);"
                          @click="toDeletePage(index)"
                          >삭제</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="body" v-if="!fieldForm && !containing">
            <dev-trigger-input-fields v-on:hideField="viewInputFieldArea" />
          </div>
        </div>
      </div>

      <!-- #END# Spinners -->
      <!-- Tags Input -->

      <!-- <div class="col-lg-6 col-md-12 col-sm-12">
                    <div class="header">
                        <h2> preview</h2>
                        
                    </div>
                    <div class="body">
                        <div class="form-group demo-tagsinput-area">
                            <div class="form-line">
                                <input type="text" class="form-control" data-role="tagsinput" value="미리보기이">
                            </div>
                        </div>
                    </div>
            </div> -->
      <!-- #END# Tags Input -->
    </div>
  </div>
</template>

<script>
import DevTriggerInputFields from "@/views/dev/trigger/DevTriggerInputFields";

import eventbus from "@/store/modules/devEventBus";

export default {
  components: {
    DevTriggerInputFields: DevTriggerInputFields,
  },
  methods: {
    viewInputFieldArea() {
      // alert(num)

      // if(num != -10){
      // this.$store.dispatch("apiDetail").then(() => {

      this.$store.state.devStore.apiSchema =
        this.$store.state.devStore.formsData;
      this.trigList = this.$store.state.devStore.apiSchema;

      // });

      // }

      console.log(this.trigList.length > 0);

      if (this.trigList.length > 0) {
        this.$route.params.fieldnum = this.trigList.length + 1;
        this.containing = !this.containing;
      } else {
        this.fieldForm = !this.fieldForm;
      }

      this.$store.state.devStore.apiSchema = null;
      this.$route.params.fieldnum = this.trigList.length;

      eventbus.$emit("fieldNum", 10);
    },
    toEditPage(index) {
      console.log(index);
      this.$store.state.devStore.apiSchema = this.trigList[index];
      this.$route.params.fieldnum = index;

      if (this.trigList != null) {
        this.containing = !this.containing;
        // return this.containing
      } else {
        this.fieldForm = !this.fieldForm;
        // return this.fieldForm
      }

      eventbus.$emit("fieldNum", 10);
    },
    toDeletePage(index) {
      if(confirm("삭제하시겠습니까?")){
        console.log(index);
        this.$store.state.devStore.apiSchema = this.trigList[index];

        var param = {
          apiCode: this.$store.state.devStore.apiCode,
          where: "input",
          count: index,
        };

        this.api.deleteApiSchema(param)
          .then((res) => {
            console.log("결과 : ", res);

            this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
            .then((res)=>{
              this.$store.dispatch("apiDetail", {result : res}).then(() => {
                // this.$store.state.devStore.apiSchema = this.$store.state.devStore.formsData
                // this.trigList = this.$store.state.devStore.apiSchema

                if (this.$store.state.devStore.formsData.length > 0) {
                  console.log("forms data 긁어 옴");

                  this.$store.state.devStore.apiSchema =
                    this.$store.state.devStore.formsData;
                  this.trigList = this.$store.state.devStore.apiSchema;

                  console.log(this.trigList);
                  this.containing = true;
                  this.fieldForm = false;
                } else {
                  this.trigList = [];
                  this.containing = false;
                  this.fieldForm = true;
                }
              });

            })
          })
          .catch(() => alert("오류가 발생했습니다. > 필드 부분"));

      }
    },
    getVisible(value) {
      var name = value.replace(/"/gi, "");
      if (name == 0) {
        return "X";
      } else {
        return "O";
      }
    },
    // setLists() {
    //   alert("reset");
    //   console.log("list reset ");
    //   var param = {
    //     apiCode: this.$store.state.devStore.apiCode,
    //     type: "__input__",
    //     index: 0,
    //   };
    //
    //   /***
    //    *
    //    * selectFields 이게 뭐로 바뀐 걸까............................................
    //    *
    //    *
    //    * */
    //
    //   this.$store
    //     .dispatch("postSend", {
    //       paths: Apiroot.api + Urls.selectFields,
    //       params: param,
    //     })
    //     .then((res) => {
    //       console.log("trigger input:", res);
    //
    //       if (res.api.length > 0) {
    //         this.containing = true;
    //         this.fieldForm = false;
    //         this.trigList = res.api;
    //       } else {
    //         this.containing = false;
    //         this.fieldForm = true;
    //       }
    //     })
    //     .catch(() => alert("오류가 발생했습니다. > request 부분"));
    // },
  },

  data() {
    return {
      fieldForm: true,
      containing: false,

      trigList: null,
    };
  },
  mounted() {},
  created() {
    this.$store.state.devStore.apiSchema = null;
    this.$route.params.fieldnum = null;
    this.trigList = null;


    console.log("input : ", this.$store.state.devStore.apiCode);

    if (this.$store.state.devStore.apiCode != null) {
      // this.$store
      //    .dispatch("apiDetail")
      //    .then(() => {
      //        console.log(this.$store.state.devStore.apiData)
      //        console.log(this.$store.state.devStore.formsData)
      //        console.log(this.$store.state.devStore.configureData)

      console.log(this.$store.state.devStore.formsData);

      if (this.$store.state.devStore.formsData.length > 0) {
        console.log("forms data 긁어 옴");

        this.$store.state.devStore.apiSchema =
          this.$store.state.devStore.formsData;
        this.trigList = this.$store.state.devStore.apiSchema;

        console.log(this.trigList);
        this.containing = true;
        this.fieldForm = false;
      }

      //    })
      //    .catch(() => alert("오류가 발생했습니다. > 인증 부분 "))
    }

    // var param = {

    //     apiCode : this.$store.state.devStore.apiCode,
    //     type : '__input__',
    //     index: 0
    // }

    // this.$store.dispatch('postSend', { paths : Apiroot.api + Urls.selectFields, params : param })
    // .then((res) => {
    //     console.log("trigger input:" , res)

    //     if(res.api != undefined){
    //         this.containing = true
    //         this.fieldForm = false
    //         this.trigList = res.api

    //     } else {
    //          this.containing = false
    //         this.fieldForm = true
    //     }

    // }).catch(() => alert('오류가 발생했습니다. > request 부분'))

    eventbus.$on("hideField", (res) => {
      console.log("메소드: ", res);

      if (res == -10) {
        this.viewInputFieldArea(res);
      }
    });
  },
  beforeDestroy() {
    this.$store.state.devStore.apiSchema = null;
  },
};
</script>
